<template>
  <NuxtLayout name="base">
    <template #navigation>
      <BaseNavigationBar
        :title="t('Назад')"
        :fallback-route="permissions.WORKSPACE.ROUTE"
      />
    </template>

    <div class="privacy-page">
      <!-- Legal Pages Navigation -->
      <nav class="legal-nav">
        <NuxtLink
          :to="permissions.LEGAL.PRIVACY.ROUTE"
          class="legal-nav__item"
          :class="{ 'legal-nav__item--active': $route.path === permissions.LEGAL.PRIVACY.ROUTE }"
        >
          Политика конфиденциальности
        </NuxtLink>
        <NuxtLink
          :to="permissions.LEGAL.CONSENT.ROUTE"
          class="legal-nav__item"
          :class="{ 'legal-nav__item--active': $route.path === permissions.LEGAL.CONSENT.ROUTE }"
        >
          Согласие на обработку данных
        </NuxtLink>
        <NuxtLink
          :to="permissions.LEGAL.COOKIES.ROUTE"
          class="legal-nav__item"
          :class="{ 'legal-nav__item--active': $route.path === permissions.LEGAL.COOKIES.ROUTE }"
        >
          Политика cookies
        </NuxtLink>
        <NuxtLink
          :to="permissions.LEGAL.ADVERTISING.ROUTE"
          class="legal-nav__item"
          :class="{ 'legal-nav__item--active': $route.path === permissions.LEGAL.ADVERTISING.ROUTE }"
        >
          Согласие на рекламу
        </NuxtLink>
      </nav>

      <h1 class="privacy-page__title">
        Политика Конфиденциальности
      </h1>

      <div class="privacy-page__intro">
        <p>Настоящая Политика конфиденциальности (далее - «Политика») определяет порядок обработки и защиты персональных данных пользователей сайта <a href="https://prod.new.queststore.space/" target="_blank">https://prod.new.queststore.space/</a> (далее - «Сайт»), осуществляемую Обществом с ограниченной ответственностью «Квест Проекты» (ОГРН 1247700644069, ИНН 9728142014, адрес: 117588, г. Москва, Новоясеневский пр-кт, д. 11) (далее - «Оператор»), в соответствии с требованиями Федерального закона № 152-ФЗ от 27.07.2006 «О персональных данных» и иных нормативных актов Российской Федерации.</p>
      </div>

      <section class="privacy-page__section">
        <h2>1. Общие положения</h2>
        <p>1.1. Оператор обеспечивает защиту обрабатываемых персональных данных от несанкционированного доступа и разглашения, утраты, уничтожения, а также иных неправомерных действий.</p>
        <p>1.2. Политика применяется ко всем персональным данным, полученным от Пользователя, как до, так и после вступления настоящей Политики в силу.</p>
        <p>1.3. Использование Сайта означает безоговорочное согласие Пользователя с настоящей Политикой.</p>
      </section>

      <section class="privacy-page__section">
        <h2>2. Правовая основа обработки</h2>
        <p>2.1. Оператор обрабатывает персональные данные на основании:</p>
        <ul>
          <li>статьи 6 Федерального закона № 152-ФЗ;</li>
          <li>согласия субъекта персональных данных;</li>
          <li>требований законодательства РФ;</li>
          <li>договоров и соглашений между Оператором и Пользователем.</li>
        </ul>
      </section>

      <section class="privacy-page__section">
        <h2>3. Состав обрабатываемых персональных данных</h2>
        <p>3.1. Оператор обрабатывает следующие категории данных: ФИО, номер телефона, адрес электронной почты, адрес проживания/пребывания, история активности на Сайте, IP-адрес, тип устройства, браузер, сведения о действиях на Сайте, cookie-файлы, дата и время входа.</p>
        <p>3.2. В случае авторизации через ЕСИА (Госуслуги), дополнительно обрабатываются: ФИО, СНИЛС, номер телефона, email и иные идентификаторы, полученные через API ЕСИА в рамках соглашения.</p>
      </section>

      <section class="privacy-page__section">
        <h2>4. Цели обработки персональных данных</h2>
        <p>4.1. Оператор осуществляет обработку персональных данных в целях: регистрации Пользователя и предоставления ему доступа к Сайту, выполнения обязательств по оказанию услуг, связи с Пользователем, включая отправку уведомлений и информации, анализа поведения Пользователя, улучшения качества сервиса, проведения маркетинговых мероприятий (при наличии отдельного согласия), исполнения требований законодательства Российской Федерации.</p>
      </section>

      <section class="privacy-page__section">
        <h2>5. Передача и хранение персональных данных</h2>
        <p>5.1. Оператор вправе передавать персональные данные третьим лицам в следующих случаях: с согласия субъекта, при необходимости предоставления услуги (например, хостинг, рассылка), в соответствии с требованиями законодательства Российской Федерации.</p>
        <p>5.2. Все третьи лица, привлекаемые к обработке, заключают с Оператором договор поручения с обязательствами соблюдения конфиденциальности.</p>
        <p>5.3. Данные хранятся не дольше, чем это необходимо для целей обработки, либо в течение 5 лет — если иное не установлено законом.</p>
      </section>

      <section class="privacy-page__section">
        <h2>6. Права субъекта персональных данных</h2>
        <p>Пользователь вправе: получить информацию об обработке своих ПДн, потребовать уточнения, блокирования или удаления данных, отозвать согласие на обработку, обжаловать действия Оператора в Роскомнадзоре или суде, осуществлять иные права, установленные ст. 14 Федерального закона № 152-ФЗ от 27.07.2006 «О персональных данных» и иных нормативных актов Российской Федерации.</p>
      </section>

      <section class="privacy-page__section">
        <h2>7. Безопасность персональных данных</h2>
        <p>7.1. Оператор применяет правовые, организационные и технические меры для защиты данных, включая: шифрование трафика, ограничение доступа по ролям, ведение журнала учёта согласий, аудит операций с ПДн, резервное копирование данных.</p>
      </section>

      <section class="privacy-page__section">
        <h2>8. Обработка файлов cookie</h2>
        <p>8.1. Сайт использует cookie для: авторизации, сохранения пользовательских настроек, аналитики посещений, маркетинговых целей (при согласии).</p>
        <p>8.2. Пользователь вправе ограничить или отключить cookie в настройках своего браузера.</p>
      </section>

      <section class="privacy-page__section">
        <h2>9. Обработка через Госуслуги (ЕСИА)</h2>
        <p>9.1. Оператор реализует возможность авторизации на Сайте с использованием Единой системы идентификации и аутентификации (ЕСИА, Госуслуги).</p>
        <p>9.2. В случае входа через ЕСИА Оператор получает от ЕСИА персональные данные в соответствии с разрешениями, выданными пользователем.</p>
        <p>9.3. Такие данные обрабатываются исключительно в рамках целей, указанных в настоящей Политике.</p>
      </section>

      <section class="privacy-page__section">
        <h2>10. Контактная информация</h2>
        <p>10.1. Для связи с Оператором по вопросам обработки ПДн, отзыва согласия или реализации прав, можно направить запрос на адрес электронной почты.</p>
      </section>

      <section class="privacy-page__section">
        <h2>11. Изменения и обновления Политики</h2>
        <p>Оператор вправе вносить изменения в настоящую Политику. Актуальная версия размещается по адресу: https://prod.new.queststore.space/legal/privacy</p>
      </section>
    </div>
  </NuxtLayout>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { permissions } from '~/shared/lib'
import { BaseNavigationBar } from '~/shared/ui'

import i18n from '../model/PrivacyPage.i18n.json'

const { t } = useI18n(i18n)

definePageMeta({
  layout: 'base',
})
</script>

<style scoped lang="scss">
.legal-nav {
  display: flex;
  flex-wrap: wrap;
  gap: rem(8px);
  margin-bottom: rem(32px);
  padding: rem(16px);
  background-color: #f8f9fa;
  border-radius: rem(8px);
  border: 1px solid #e9ecef;

  &__item {
    padding: rem(8px) rem(16px);
    border-radius: rem(20px);
    border: 1px solid #dee2e6;
    background-color: #fff;
    color: #6c757d;
    text-decoration: none;
    font-size: rem(14px);
    font-weight: 500;
    white-space: nowrap;
    transition: all 0.2s ease;

    &:hover {
      background-color: #e9ecef;
      border-color: #adb5bd;
    }

    &--active {
      background-color: #007bff;
      color: #fff;
      border-color: #007bff;

      &:hover {
        background-color: #0056b3;
        border-color: #0056b3;
      }
    }
  }
}

@media (width <= 768px) {
  .legal-nav {
    padding: rem(12px);
    gap: rem(6px);

    &__item {
      padding: rem(6px) rem(12px);
      font-size: rem(12px);
    }
  }
}

.privacy-page {
  max-width: rem(800px);
  margin: 0 auto;
  padding: rem(48px);
  background-color: #fff;
  border-radius: rem(8px);

  &__title {
    font-size: rem(32px);
    font-weight: 700;
    margin-bottom: rem(16px);
    color: #1a1a1a;
  }

  &__intro {
    margin-bottom: rem(32px);

    p {
      font-size: rem(16px);
      line-height: 1.6;
      color: #333;
    }

    a {
      color: #06c;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  &__section {
    margin-bottom: rem(40px);

    h2 {
      font-size: rem(24px);
      font-weight: 600;
      margin-bottom: rem(16px);
      color: #1a1a1a;
    }

    h3 {
      font-size: rem(18px);
      font-weight: 600;
      margin-top: rem(16px);
      margin-bottom: rem(12px);
      color: #2c2c2c;
    }

    p {
      font-size: rem(16px);
      line-height: 1.6;
      color: #333;
      margin-bottom: rem(12px);
    }

    ul {
      list-style-type: disc;
      margin-left: rem(24px);
      margin-bottom: rem(16px);

      li {
        font-size: rem(16px);
        line-height: 1.6;
        color: #333;
        margin-bottom: rem(8px);
      }
    }
  }
}

@media (width <= 768px) {
  .privacy-page {
    padding: rem(32px) rem(24px);

    &__title {
      font-size: rem(24px);
    }

    &__section {
      h2 {
        font-size: rem(20px);
      }

      h3 {
        font-size: rem(16px);
      }
    }
  }
}
</style>
